module.exports = __webpack_public_path__ + "img/signal_wifi_statusbar_connected_no_internet_26x24px.1cb87fe1.svg";